var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('surveys-grid',{attrs:{"type":2,"items":_vm.surveys,"page-title":_vm.pageTitle,"return-page":"surveys","empty-text":_vm.$t('No quizzes or surveys'),"extended-buttons":""},on:{"refresh":_vm.refresh}})}
var staticRenderFns = []

export { render, staticRenderFns }